import { Link } from "react-router-dom";

const FooterColumn = ({ title, links }) => {
  return (
    <div>
      {/* Title + Divider */}
      <div>
        <h3 className="text-[#FFDF20] font-semibold">{title}</h3>
        <div className="w-full h-[1px] bg-[#1447E6] mt-2"></div>
      </div>

      {/* Links */}
      <ul className="mt-4 space-y-2 text-sm pl-0">
        {links.map((link, index) => (
          <li key={index}>
            <Link
              to={link.path}
              className="block text-[#D1D5DC] hover:text-[#FFDF20] hover:underline underline-offset-4 transition"
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterColumn;
